// @ts-ignore
import dayjs from 'dayjs';

// TODO:: util 로 옮기기
const formattedMDTimeDate = (date: Date | undefined | string) => {
  if (!date) return '';

  const day = dayjs(date).format('YYYY-M-DD');
  const dateArr = day.split('-');
  const time = dayjs(new Date(date)).format('HH:mm');

  return `${dateArr[1]}월 ${dateArr[2]}일 ${time}`;
};

export default formattedMDTimeDate;
